module.exports = __webpack_public_path__ + "img/iq.8d936728.svg";